module.exports = __webpack_public_path__ + "static/tyrant04-7003ae7ea76c3971b23dea5cb680d3f3.png";